<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="所属门店：" prop="memberLeveType">
            <el-select v-model="searchForm.shopId" @change="shopChangeBtn" placeholder="请选择" class="mt-search-width">
              <el-option
                v-for="item in shopArr"
                :key="item.id"
                :label="item.shopName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型：" prop="memberLeveType">
            <el-select v-model="searchForm.memberLeveType" placeholder="请选择" class="mt-search-width">
              <el-option
                v-for="item in memberLeveTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员等级：" prop="memberLevelId">
            <el-select v-model="searchForm.memberLevelId" placeholder="请选择" class="mt-search-width">
              <el-option
                v-for="item in memberLevelList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="shopName"
            label="所属门店">
          </el-table-column>
          <el-table-column
            align="center"
            prop="money"
            label="余额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="memberLevelName"
            label="用户类型">
            <template slot-scope="scope">
              <span>{{scope.row.memberLevelType == 1 ? '会员' : scope.row.memberLevelType == 2 ? '内部员工' : scope.row.memberLevelType == 3 ? '合伙人' : '普通用户'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="memberLevelType"
            label="会员等级">
            <template slot-scope="scope">
              <span>{{scope.row.memberLevelName == null ? '--' : scope.row.memberLevelName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="integral"
            label="积分">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { queryShopAppUserListByUserId, queryAllUserMemberLevelList, queryAllShopInfoList} from '@/api/user'
export default {
  name: 'UserDetail',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
         shopId:'',
         memberLevelType:'',
         memberLevelId:''
      },
      memberLeveTypeArr: this.$memberLeveTypeArr,
      memberLevelList: [],
      shopArr:[]
    }
  },
  mounted () {
    this.shopListFun();
    var memberLevelType = this.searchForm.memberLevelType
    this.memberLevelListFun(memberLevelType);
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    shopChangeBtn(){
      var memberLevelType = this.searchForm.memberLevelType
      this.memberLevelListFun(memberLevelType);
    },
    /* 店铺列表 */
    shopListFun () {
      var that = this
      queryAllShopInfoList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.shopArr = data
        }
        if (res.errorCode === '4002') {
          that.shopArr = []
        }
      })
    },
    /* 会员等级列表 */
    memberLevelListFun (memberLevelType) {
      var that = this
      console.log(that.searchForm.shopId,memberLevelType);
      queryAllUserMemberLevelList({shopId:that.searchForm.shopId,memberLevelType:memberLevelType}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.memberLevelList = data
        }
        if (res.errorCode === '4002') {
          that.memberLevelList = []
        }
      })
    },
    // 获取数据
    getInfoList () {
      let that = this
      let memberLevelType = that.searchForm.memberLevelType
      let memberLevelId = that.searchForm.memberLevelId
      let shopId = that.searchForm.shopId
      let dataId = that.dataId
      let page = that.currentPage
      queryShopAppUserListByUserId({ id: that.dataId, shopId: shopId, memberLevelType: memberLevelType, memberLevelId: memberLevelId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/UserDetail.vue